// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'supText'
})
export class SupTextPipe implements PipeTransform {
  transform(value: number, supList?: string[]): any {
    if (value) {
      return this.toOrdinal(value, supList);
    }
    return;
  }

  toOrdinal(value: any, supTextList: any): string {
    const last = value % 100;
    const suffix = supTextList;
    const ordinal =
      last < 21
        ? last < 4
          ? suffix[last]
          : suffix[0]
        : last % 10 > 3
        ? suffix[0]
        : suffix[last % 10];
    return ordinal;
  }
}
